export type Toast = {
  type: "success" | "error" | "warning" | "info";
  message: string;
  duration?: number;
};

const KEY = "__flash_toast__";

export function pushToast(toast: Toast) {
  sessionStorage.setItem(KEY, JSON.stringify(toast));
}

export function popToast(): Toast | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    return JSON.parse(raw) as Toast;
  } catch {
    return null;
  }
}
